// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ApplicationsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ApplicationsIcon" ref={forwardedRef} {...props}>
      <path d="M8.375 7.5a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75" />
      <path d="M11.75 6.625a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0" />
      <path d="M13.375 7.5a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75" />
      <path d="M4.017 2.999a1 1 0 0 0-1 1V15.98a1 1 0 0 0 1 1H16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm.5 1.5H15.5v3.876H4.517zm0 10.982V9.625H15.5v5.856z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ApplicationsIcon = /* @__PURE__ */ Object.assign(
  ApplicationsIconComponent,
  { displayName: 'ApplicationsIcon' },
);
